import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import WhiteCard from "src/shared/components/WhiteCard";

interface HealthInformationCardProp {
  caption: string;
  header: string;
  list: {
    header: string;
    items: string[];
  };
  onNext: () => void;
}

const HealthInformationCard = ({
  caption,
  header,
  list,
  onNext,
}: HealthInformationCardProp) => {
  const { t } = useTranslation();
  const translatedCaption = t(caption);
  const translatedHeader = t(header);
  const translatedListHeader = t(list.header);

  return (
    <WhiteCard
      gap={2}
      sx={{ backgroundColor: "rgba(0, 181, 184, 0.25)", borderRadius: "30px" }}
      onClick={onNext}
    >
      <Typography variant="body1">{translatedCaption}</Typography>
      <Typography variant="h5" fontWeight={600}>
        {translatedHeader}
      </Typography>
      <Stack spacing={1}>
        <Typography variant="h6" fontWeight={550}>
          {translatedListHeader}
        </Typography>
        <Box
          component="ul"
          sx={{
            listStyleType: "disc",
            listStylePosition: "outside",
            pl: 4,
            m: 0,
          }}
        >
          {list.items.map((i) => (
            <Typography
              key={i}
              component="li"
              variant="h6"
              fontWeight={550}
              sx={{ display: "list-item" }}
            >
              {t(i)}
            </Typography>
          ))}
        </Box>
      </Stack>
    </WhiteCard>
  );
};

export default HealthInformationCard;
